import { Injectable } from '@angular/core';

import { EntityStore, StoreConfig } from '@datorama/akita';

import { AccountUsersState } from './account-users.state';

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'accountUsers', resettable: true, idKey: 'id' })
export class AccountUsersStore extends EntityStore<AccountUsersState> {
  constructor() {
    super();
  }
}
